import { render, staticRenderFns } from "./TransferCard.vue?vue&type=template&id=d9b60d80&scoped=true"
import script from "./TransferCard.vue?vue&type=script&lang=js"
export * from "./TransferCard.vue?vue&type=script&lang=js"
import style0 from "./TransferCard.vue?vue&type=style&index=0&id=d9b60d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b60d80",
  null
  
)

export default component.exports